(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-intro-animation"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setupIntro(sectionEl) {
    if (!sectionEl) return;

    var sectionId = sectionEl.getAttribute('data-section-id') || '';
    var storageKey = 'intro_anim_' + sectionId;

    // 调试通过后可开启只播放一次逻辑
    // if (sessionStorage.getItem(storageKey)) {
    //   sectionEl.classList.add('anim-done');
    //   sectionEl.style.visibility = 'hidden';
    //   sectionEl.style.pointerEvents = 'none';
    //   return;
    // }

    function runAnimation() {
      // 双 requestAnimationFrame，确保初始状态先渲染一帧，再开始动画
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          sectionEl.classList.add('animate-start');

          var slideDur = Number(sectionEl.getAttribute('data-slide-duration')) || 1400;
          var exitDelay = Number(sectionEl.getAttribute('data-exit-delay')) || 300;
          var exitDur = Number(sectionEl.getAttribute('data-exit-duration')) || 800;

          // 等待「蒙版滑动 + 延迟」完成
          setTimeout(function () {
            // 强制重排，保证 transform 过渡能触发
            void sectionEl.offsetHeight;
            sectionEl.classList.add('anim-done');

            // 等待整体上移动画结束后彻底隐藏 DOM
            setTimeout(function () {
              sectionEl.style.visibility = 'hidden';
              sectionEl.style.pointerEvents = 'none';
              // sessionStorage.setItem(storageKey, '1');
            }, exitDur);
          }, slideDur + exitDelay);
        });
      });
    }

    runAnimation();
  }

  function initAllIntros() {
    var sections = document.querySelectorAll('.collection-intro-animation');
    sections.forEach(setupIntro);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllIntros);
  } else {
     initAllIntros();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
// document.addEventListener('DOMContentLoaded', function(){
//   const headerDom = document.querySelector('#header-component');
//   const appLi = document.querySelector('.menu-list__list-item-dropdown');
//   if(!appLi || !headerDom) return;

//   const originBg = getComputedStyle(headerDom).backgroundColor;
//   const targetHoverBg = '#ffffff';

//   const dropdownWrap = appLi.querySelector('.simple-dropdown__wrap');
//   const linkEl = appLi.querySelector('.menu-list__link');
//   if(!dropdownWrap || !linkEl) return;

//   // 统一关闭下拉工具函数
//   function closeDropdown(){
//     dropdownWrap.classList.remove('is-open');
//     headerDom.style.backgroundColor = originBg;
//   }
//   // 打开下拉
//   function openDropdown(){
//     // 关闭页面其他同类型下拉
//     document.querySelectorAll('.simple-dropdown__wrap').forEach(d=>{
//       d.classList.remove('is-open');
//     })
//     dropdownWrap.classList.add('is-open');
//     headerDom.style.backgroundColor = targetHoverBg;
//   }

//   // 桌面悬浮
//   appLi.addEventListener('mouseenter', () => {
//     openDropdown();
//   })

//   appLi.addEventListener('mouseleave', () => {
//     closeDropdown();
//   })

//   // 移动端点击
//   linkEl.addEventListener('click', function(e){
//     if(window.innerWidth <= 768){
//       e.preventDefault();
//       if(dropdownWrap.classList.contains('is-open')){
//         closeDropdown();
//       }else{
//         openDropdown();
//       }
//     }
//   })

//   // 点击空白关闭
//   document.addEventListener('click', function(e){
//     if(!e.target.closest('.menu-list__list-item-dropdown')){
//       closeDropdown();
//     }
//   })

//   // resize重置全部状态
//   window.addEventListener('resize', ()=>{
//     closeDropdown();
//   })
// })
document.addEventListener('DOMContentLoaded', function(){
  const headerDom = document.querySelector('#header-component');
  const itemList = document.querySelectorAll('.menu-list__list-item-dropdown');
  if(!headerDom || itemList.length === 0) return;

  const originBg = getComputedStyle(headerDom).backgroundColor;
  const targetHoverBg = '#ffffff';

  // 关闭全部下拉公共方法
  function closeAllDropdown(){
    document.querySelectorAll('.menu-list__list-item-dropdown').forEach(li=>{
      const wrap = li.querySelector('.simple-dropdown__wrap');
      if(wrap) wrap.classList.remove('is-open');
    })
    headerDom.style.backgroundColor = originBg;
  }

  itemList.forEach(function(liEl){
    const dropdownWrap = liEl.querySelector('.simple-dropdown__wrap');
    const linkEl = liEl.querySelector('.menu-list__link');
    if(!dropdownWrap || !linkEl) return;

    function openCurrentDropdown(){
      closeAllDropdown();
      dropdownWrap.classList.add('is-open');
      headerDom.style.backgroundColor = targetHoverBg;
    }
    function closeCurrentDropdown(){
      dropdownWrap.classList.remove('is-open');
      // 判断是否还有其他打开的下拉，没有才恢复背景
      const hasOpen = document.querySelector('.simple-dropdown__wrap.is-open');
      if(!hasOpen){
        headerDom.style.backgroundColor = originBg;
      }
    }

    // 桌面悬浮
    liEl.addEventListener('mouseenter', () => {
      openCurrentDropdown();
    })
    liEl.addEventListener('mouseleave', () => {
      closeCurrentDropdown();
    })

    // 移动端点击
    linkEl.addEventListener('click', function(e){
      if(window.innerWidth <= 768){
        e.preventDefault();
        if(dropdownWrap.classList.contains('is-open')){
          closeCurrentDropdown();
        }else{
          openCurrentDropdown();
        }
      }
    })
  })

  // 点击空白关闭
  document.addEventListener('click', function(e){
    if(!e.target.closest('.menu-list__list-item-dropdown')){
      closeAllDropdown();
    }
  })

  // resize重置全部
  window.addEventListener('resize', ()=>{
    closeAllDropdown();
  })
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
